import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container, Button, UncontrolledTooltip } from "reactstrap";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import UserUtils from "src/services/utils/UserUtils";
import AiAssistantChat from "../AiAssistantChat";
import { isFeatureEnabledForActiveModule } from "src/helpers/module_helper";
import AIAvatar from "src/assets/images/users/ai.jpeg";

const availableModules = [
    'wb',
    'cm',
    'tp',
    'gd'
];

const Footer = ({
    t,
    user,
    modules,
    organization
}) => {
    const chatBoxRef = useRef(null);
    const chatButtonRef = useRef(null);

    const [ showAiAssistantChat, setShowAiAssistantChat ] = useState(false);
    const [ isChatFeatureEnabledForOrg, setIsChatFeatureEnabledForOrg ] = useState(false);

    const userUtils = new UserUtils();

    const renderManualLinks = () => {
        if(!modules.active || !availableModules.includes(modules.active)){
            return null;
        }

        let route = userUtils.isAnalystOrAnalystAdmin(user) ? "/admin/" : userUtils.isEmployee(user) ? "/employee/" : "/third-party/";

        return (
            <>
                <Link to={`${route}user_policy`} className="m-3">
                    {t("User policy")}
                </Link>
                <Link to={`${route}data_privacy`}>
                    {t("Data privacy")}
                </Link>
            </>
        )
    }

    useEffect(() => {
        if (modules.active && modules.featuresLoadingStatus === 'loaded') {
            setIsChatFeatureEnabledForOrg(
                isFeatureEnabledForActiveModule('chatbot_assistant')
            )
        }
    }, [
        modules.active,
        modules.featuresLoadingStatus
    ]);

    useEffect(() => {
        if (isChatFeatureEnabledForOrg) {
            const handleClickOutside = (event) => {
                if (
                    chatBoxRef.current?.contains(event.target) ||
                    chatButtonRef.current?.contains(event.target)
                ) {
                    return;
                }

                setShowAiAssistantChat(false);
            };

            document.addEventListener('mousedown', handleClickOutside);

            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [
        isChatFeatureEnabledForOrg
    ]);

    return (
        <React.Fragment>
            <footer className="footer">
                {isChatFeatureEnabledForOrg && (
                    <>
                        <AiAssistantChat 
                            isOpen={showAiAssistantChat}
                            user={user}
                            orgId={organization?.id}
                            currentModule={modules.active}
                            boxRef={chatBoxRef}
                            toggleOpen={() => setShowAiAssistantChat(!showAiAssistantChat)}
                        />

                        <Button
                            color='none'
                            type='button'
                            className='ai-assistant-btn bg-white'
                            onClick={() => setShowAiAssistantChat(!showAiAssistantChat)}
                            innerRef={chatButtonRef}
                            id="maya-ai-doc-assistant"
                        >
                            <div className="ai-assistant-avatar-wrapper">
                                <img
                                    src={AIAvatar}
                                    alt="Maya"
                                    className="ai-assistant-avatar"
                                />

                                <span className="ai-assistant-online" />
                            </div>

                            <span className="ai-assistant-name">
                                Maya
                            </span>

                            <UncontrolledTooltip
                                placement="left"
                                target="maya-ai-doc-assistant"
                            >
                                {t('Ask Maya – AI Documentation Assistant')}
                            </UncontrolledTooltip>
                        </Button>
                    </>
                )}

                <Container fluid>
                    <Row>
                        <Col md={8}>
                            {`© 2026 SMART INTEGRITY PLATFORM.  ${t('All rights reserved by')} DISS-CO ®.`}
                            {renderManualLinks()}
                        </Col>
                        <Col md={4} className="text-sm-left text-md-end">
                            {`${t("Version")}: ${process.env.REACT_APP_SIP_VERSION}`}
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

const mapStatetoProps = (state) => {
    const { user } = state.Login;

    return { 
        user, 
        modules: state.Modules,
        organization: state.Organization
    };
};

export default connect(mapStatetoProps, {})(withNamespaces()(Footer));
